import FacebookIcon from "src/assets/icons/FacebookIcon";
import TwitterIcon from "src/assets/icons/TwitterIcon";
import { BookIcon } from "src/components/support/assets/icons";
import VRIcon2 from "src/assets/icons/VRIcon2";
import ChevronIcon from "src/assets/icons/ChevronIcon";
import EarthIcon from "src/assets/icons/EarthIcon";
import QuestionIcon from "src/assets/icons/QuestionIcon";
import OutlinedDeviceIcon from "src/assets/icons/OutlinedDeviceIcon";
import DiscountLabel from "src/assets/icons/DiscountLabel";
import HapticIcon from "src/assets/icons/HapticIcon";
import CameraBasedHandTrackingIcon from "src/assets/icons/CameraBasedHandTrackingIcon";
import FourSizesIcon from "src/assets/icons/FourSizesIcon";
import PlayTimeIcon from "src/assets/icons/PlayTimeIcon";
import DelicateControlIcon from "src/assets/icons/DelicateControlIcon";
import BleConnectivityIcon from "src/assets/icons/BleConnectivityIcon";
import InnerGlovesIcon from "src/assets/icons/InnerGlovesIcon";
import AntiSlipIcon from "src/assets/icons/AntiSlipIcon";
import NoticeIcon from "src/assets/icons/NoticeIcon";
import { ArrowLeftIcon, ArrowRightIcon } from "@/components/home/assets/icons";
import QuestBadge from "@/assets/icons/QuestBadge";
import GameShopIcon from "@/assets/icons/GameShopIcon";
import SteamIcon from "@/components/content/SteamIcon";
import QuestIcon from "@/components/content/QuestIcon";
import VestIcon, { VestWideIcon } from "@/components/content/VestIcon";
import HeadIcon, { HeadWideIcon } from "@/components/content/HeadIcon";
import HandIcon, { HandWideIcon } from "@/components/content/HandIcon";
import FootIcon, { FootWideIcon } from "@/components/content/FootIcon";
import ArmIcon, { ArmWideIcon } from "@/components/content/ArmIcon";
import GloveIcon, { GloveWideIcon } from "@/components/content/GloveIcon";
import DownloadIcon1 from "@/assets/icons/DownloadIcon1";
import GuideIcon from "@/assets/icons/GuideIcon";
import SortIcon from "@/v2-components/core/icon/SortIcon";

const Icons = {
  sort: SortIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-left": ArrowLeftIcon,
  "tactsuit-outlined": (...props: any) =>
    OutlinedDeviceIcon({ ...props, name: "tactsuit" }),
  "tactosy-for-arms-outlined": (...props: any) =>
    OutlinedDeviceIcon({ ...props, name: "tactosy-for-arms" }),
  "camerat-based-tracking": CameraBasedHandTrackingIcon,
  "delicate-control": DelicateControlIcon,
  "ble-connectivity": BleConnectivityIcon,
  "inner-gloves": InnerGlovesIcon,
  "anti-slip": AntiSlipIcon,
  haptic: HapticIcon,
  "play-time": PlayTimeIcon,
  "4-sizes": FourSizesIcon,
  question: QuestionIcon,
  earth: EarthIcon,
  chevron: ChevronIcon,
  vr2: VRIcon2,
  book: BookIcon,
  twitter: TwitterIcon,
  facebook: FacebookIcon,
  notice: NoticeIcon,
  discount: DiscountLabel,
  "quest-badge": QuestBadge,
  "game-shop": GameShopIcon,
  steam: SteamIcon,
  quest: QuestIcon,
  Vest: VestIcon,
  VestWide: VestWideIcon,
  Head: HeadIcon,
  HeadWide: HeadWideIcon,
  Hand: HandIcon,
  HandWide: HandWideIcon,
  Glove: GloveIcon,
  GloveWide: GloveWideIcon,
  Foot: FootIcon,
  FootWide: FootWideIcon,
  Arm: ArmIcon,
  ArmWide: ArmWideIcon,
  download: DownloadIcon1,
  guide: GuideIcon,
} as const;

type Name = keyof typeof Icons;

export const Icon = ({ name, ...rest }: { name: Name; [key: string]: any }) => {
  if (!name) {
    return null;
  }

  const Icon = Icons[name];

  if (!Icon) {
    return null;
  }

  return <Icon {...rest} />;
};
